import React from "react";
import Layout from "../../components/common/layout";
import LinkSkillsTable from "../../components/tables/LinkSkillsTable";

export default () => {
  return (
    <Layout>
      <LinkSkillsTable />
    </Layout>
  );
};
